import React, { Component } from 'react';
import { dispatch } from 'react-redux';
import { Grid, Row, Col, Jumbotron } from 'react-bootstrap';
import {  connect } from 'react-redux'
import ReviewDocument from './review-document';
import SignDocument from './sign-document';
import { Redirect } from 'react-router';
import { HashLink as Link } from 'react-router-hash-link';
import veri_sign from '../logo-verisign.png';
import inituit_logo from '../intuit-logo.png';
import { clearUser} from '../actions/creators';
import TrustEBrandLogo from "./truste-brand-logo";

class MainPage extends Component {

    constructor(props) {
        super(props);
    }


    signOut(e){
        this.props.clearUser(this.state);
    }

    render() {

        if(this.props.returnStatus == "SIGNED"  && this.props.login == false){
            this.props.clearUser(this.state);
            return (<Redirect to="/sign_out" />)
        }

        if(this.props.login == "false" || this.props.login == false){
            return (<Redirect to="/sign_in" />)
        }

        if(this.props.returnStatus == "SIGNED"){
            return(
                <div className="custom">
                    <script>

                        function signOut() {
                    }
                    </script>
                    <Grid>
                        <Jumbotron>
                            <Row>
                                <Col className="divider" sm={3}>

                                </Col>
                                <Col sm={6}>
                                    <ReviewDocument/>
                                </Col>
                                <Col sm={3}>

                                </Col>
                            </Row>
                        </Jumbotron>
                    </Grid>
                </div>
            );
        }

        return (

            <div className="custom">
                <script>

                    function signOut() {
                }
                </script>

                <Grid>
                    <Row>
                        <table className="user-details-table">
                        <tbody>
                        <td className="user-details">

                            <span className="user-details-info"><b>{this.props.userName}</b></span><br />
                            <span className="user-details-info"><b>{this.props.email}</b></span>

                            <br />
                            <Link to="/sign_out" onClick={e => this.signOut(e)}><font color="white" size="2"><u>sign out</u></font></Link>
                        </td>
                        </tbody>
                        </table>

                    </Row>

                    <Jumbotron className="logged-in">
                        <Row>
                            <Col className="divider" sm={6}>
                                <ReviewDocument/>
                            </Col>
                            <Col sm={6}>
                                <SignDocument/>
                            </Col>
                        </Row>
                    </Jumbotron>
                    <Row>
                        <table className="logo-table">
                            <tbody>
                            <td className="left-brand-logo">
                                <img src={inituit_logo} alt="logo" width="120" height="40"/> <br/>
                                <Link to="/tnc" target="_blank"><font size="1.9" color="blue">Terms of
                                    Service</font></Link> |<a href="https://quickbooks.intuit.com/r/"
                                                              target="_blank"><font color="blue" size="1.75">
                                Privacy</font></a> <br/>
                                <font color="#00008b" size="1.75"> © 2019 Intuit Inc. All rights
                                    reserved.</font><br/>
                            </td>
                            <td className="right-brand-logo">
                                <TrustEBrandLogo />
                                <a href="https://sealinfo.verisign.com/splash?lang=en&dn=tax%2Design%2Eintuit%2Ecom&form%5Ffile=fdf%2Fsplash%2Efdf"
                                   target="_blank"> <img src={veri_sign} alt="logo" width="130" height="60"/></a>
                            </td>
                            </tbody>
                        </table>
                    </Row>
                </Grid>
            </div>

        );
    }
}


const mapStateToProps = ( state ) => {
    return {
        userName:state.userName,
        email:state.email,
        login:state.login,
        planEin:state.planEin,
        planId:state.planId,
        year:state.taxYear,
        token:state.token,
        realmId:state.realmId,
        documentName:state.documentName,
        taxReturnId:state.taxReturnId,
        returnStatus:state.returnStatus
    }

};

const mapDispatchToProps = dispatch => {
    return {
        clearUser: (state) => {
            dispatch(clearUser(state))
        }
    };
};

export default connect(mapStateToProps,mapDispatchToProps)(MainPage);